export function clamp(n, min, max) {
  return Math.min(max, Math.max(min, n));
}

export function scrollToId(id) {
  const el = document.getElementById(id);
  if (!el) return;
  el.scrollIntoView({ behavior: "smooth", block: "start" });
}

